export const learnMore = (onClick) => {
  return {
    title: "Learn more about this behaviour",
    icon: "LEARN_MORE",
    context:
      "Find out which sensors it uses, how change is detected and much more.",
    onClick: onClick,
  };
};
